<template>
  <div class="menu-demo">
    <el-menu
      v-for="(item, i) in list"
      :key="i"
      router
      unique-opened
      mode="horizontal"
      class="el-menu-vertical-demo">
      <el-menu-item 
        v-if="!item.children||item.children.length === 0" 
        :index="item.url" 
        :class="{'submenu-active': activeIndex[0] === item.url}"
      >
        <i v-if="item.className" :class="item.className" />
        <icon-svg v-else-if="item.icon" :icon-class="item.icon" />
        <img class="img" v-else :src="item.img" />
        <span slot="title" class="name">{{ item.name }}</span>
      </el-menu-item>

      <el-submenu 
        v-else 
        :index="item.url" 
        :class="{'submenu-active': activeIndex[0] === item.url}">
        <template slot="title">
          <i v-if="item.className" :class="item.className" />
          <icon-svg v-else-if="item.icon" :icon-class="item.icon" />
          <img class="img" v-else :src="item.img" />
          <span slot="title" class="name">{{ item.name }}</span>
        </template>
        <!-- 二级菜单 -->
        <el-menu-item-group 
          v-for="(itemChildren, index) in item.children" 
          :key="index" 
          :class="{'two-submenu-active': activeIndex[1] === itemChildren.commonUrl}"
        >
          <el-menu-item
            v-if="!itemChildren.children||itemChildren.children.length === 0" 
            class="two-el-menu-item"
            :index="itemChildren.commonUrl" 
            :route="{path: itemChildren.url}"
          >{{ itemChildren.name }}</el-menu-item>
          <!-- 三级菜单 -->
          <el-submenu 
            v-else 
            :index="itemChildren.commonUrl" 
            class="two-menu"
          >
            <template slot="title">
              <span slot="title" class="name">{{ itemChildren.name }}</span>
            </template>
            <el-menu-item 
              v-for="(itemThreeChildren, threeIndex) in itemChildren.children" 
              :key="threeIndex"
              :class="{'three-submenu-active': activeIndex[2] === itemThreeChildren.commonUrl}"
              :index="itemThreeChildren.commonUrl"
              :route="{path: itemThreeChildren.url}"
              >{{ itemThreeChildren.name }}</el-menu-item>
            </el-submenu>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import authMixins from '@/common/mixins/auth.js'
import { getSetFlag } from "@/common/js/storage";
export default {
  mixins: [authMixins],

  data() {
    return {
      // 页面高亮集合
      activeIndex: []
    }
  },

  watch: {
    $route(to, form) {
      this.activeIndex = this.setCurrentRoute()
    }
  },

  created() {
    this.activeIndex = this.setCurrentRoute()
    if (getSetFlag()) this.initUserMenuAuthTree()
  },

  methods: {
    /** 
     * @desc 获取当前页面url及父级页面url集合
    */
    setCurrentRoute() {
      let path = this.$router.history.current.path.split('/')
      let arr = []
      let url = ''
      path.map((i, index) => {
        if (index>0 && index<4) {
          url += `/${i}`
          arr.push(url)
        }
      })
      return arr
    },
  }
}
</script>

<style lang='scss'>
.menu-demo {
  @include flex-start;
  .el-menu {
    width: 104px;
    border-bottom: none;
    margin-right: 14px;
    .el-submenu.is-active .el-submenu__title {
      border-bottom: none;
    }
    .el-submenu .el-submenu__icon-arrow {
      margin-top: 2px;
      font-weight: 800;
      color: $baseGrey;
    }
    .el-submenu {
      .el-submenu__title {
        height: 40px;
        box-sizing: border-box;
        @include flex-start;
        color: $baseTwoGrey;
      }
    }
    .name, 
    .el-menu-item {
      height: 40px;
      box-sizing: border-box;
      @include flex-start;
      color: $baseTwoGrey;
    }
    .submenu-active {
      background: $baseTwoSnow;
      border-radius: 4px;
      .name {
        color: $baseGrey;
      }
    }
  }
  .el-menu:last-child {
    margin-right: 0px;
  }
}

.el-menu--horizontal {
  width: 128px;
  .el-menu-item.is-active {
    border-bottom: none;
  }
  .el-menu--popup {
    min-width: 128px;
    // 二级菜单
    .el-menu-item-group {
      .el-menu-item-group__title {
        padding: 0px;
      }
      ul {
        li {
          font-size: 14px;
          color: $baseGrey;
          margin: 4px 8px;
        }
        .two-el-menu-item {
          // 二级菜单下没有有子菜单灰色高亮
          &:hover {
            background: $baseTwoSnow;
            border-radius: 4px;
          }
        }
        .el-submenu {
          .el-submenu__title {
            height: 40px;
            box-sizing: border-box;
            @include flex-start;
            color: $baseGrey;
            // 二级菜单下还有子菜单蓝色高亮
            &:hover {
              color: $baseBlue;
              background: $twoMenuHing;
              border-radius: 4px;
              .el-submenu__icon-arrow {
                color: $baseBlue;
              }
            }
          }
          // 三级菜单
          .el-menu--horizontal {
            min-width: 133px;
            .el-menu--popup-right-start {
              margin-left: 10px;
            }
            .el-menu--popup {
              min-width: auto;
              .el-menu-item {
                min-width: auto;
                // 三级菜单鼠标移动高亮
                &:hover {
                  background: $baseTwoSnow;
                  border-radius: 4px;
                }
              }
              // 三级菜单选中高亮
              .three-submenu-active {
                background: $baseTwoSnow;
                border-radius: 4px;
              }
            }
          }
        }
      }
    }
    // 二级菜单高亮
    .two-submenu-active {
      ul {
        /* 二级菜单下没有子菜单灰色色高亮 */
        .two-el-menu-item {
          color: $baseGrey;
          background: $baseTwoSnow;
          border-radius: 4px;
        }
        .el-submenu__title {
          /* 二级菜单下还有子菜单蓝色高亮 */
          background: $twoMenuHing;
          border-radius: 4px;
          .name {
            color: $baseBlue;
          }
          .el-submenu__icon-arrow {
            color: $baseBlue;
          }
        }
      }
    }
  }
}
</style>
